import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { path: '/', label: '首页' },
  { path: '/category/anquan-denglu', label: '安全登录' },
  { path: '/category/shiyong-zhinan', label: '使用指南' },
  { path: '/category/pingtai-dongtai', label: '平台动态' },
  { path: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-cloud-line text-background-50 text-lg"></i>
            </div>
            <span className={`font-heading text-xl font-bold ${scrolled ? 'text-foreground-900' : 'text-background-50'}`}>
              开云登录
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === link.path
                    ? scrolled
                      ? 'text-primary-600 bg-primary-100/70'
                      : 'text-background-50 bg-white/15'
                    : scrolled
                      ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-200/70'
                      : 'text-background-50/85 hover:text-background-50 hover:bg-white/15'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`px-5 py-2 rounded-md text-sm font-medium transition-all whitespace-nowrap ${
                scrolled
                  ? 'border border-primary-300 text-primary-600 hover:bg-primary-50'
                  : 'border border-background-50/40 text-background-50 hover:bg-white/15'
              }`}
            >
              联系我们
            </Link>
            <Link
              to="/about"
              className="px-5 py-2 rounded-md text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-all whitespace-nowrap"
            >
              立即登录
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg ${
              scrolled ? 'text-foreground-700' : 'text-background-50'
            }`}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block px-4 py-2.5 rounded-md text-sm font-medium transition-colors ${
                  location.pathname === link.path
                    ? 'text-primary-600 bg-primary-100/70'
                    : 'text-foreground-700 hover:bg-background-200/70'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="pt-3 border-t border-background-200/70 flex gap-3">
              <Link
                to="/about"
                className="flex-1 text-center px-4 py-2.5 rounded-md text-sm font-medium border border-primary-300 text-primary-600 hover:bg-primary-50 transition-all whitespace-nowrap"
              >
                联系我们
              </Link>
              <Link
                to="/about"
                className="flex-1 text-center px-4 py-2.5 rounded-md text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-all whitespace-nowrap"
              >
                立即登录
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}